import { OpenArtifactButton } from './artifacts/ArtifactContext';
import { extractFiles } from './artifacts/files';
import { DownloadIcon, FileTextIcon, SheetIcon } from './icons';
import './FileAttachments.css';

/**
 * Fichiers générés cités dans une réponse (Excel, PDF, Word) : une carte par fichier,
 * avec « Aperçu » (panneau d'artefacts) et « Télécharger ».
 */
export function FileAttachments({ content, messageId }) {
  const files = extractFiles(content);
  if (!files.length) return null;

  return (
    <ul className="file-cards" aria-label="Fichiers générés">
      {files.map((file) => {
        const Icon = file.ext === 'xlsx' || file.ext === 'csv' ? SheetIcon : FileTextIcon;
        const artifactId = `${messageId}:file:${file.url}`;
        return (
          <li key={file.url} className="file-card">
            <span className={`file-card__icon file-card__icon--${file.ext || 'other'}`} aria-hidden="true">
              <Icon size={20} />
            </span>
            <span className="file-card__text">
              <span className="file-card__name" title={file.name}>{file.name}</span>
              <span className="file-card__type">{file.type.label}</span>
            </span>
            <span className="file-card__actions">
              <OpenArtifactButton
                artifactId={artifactId}
                label={`Aperçu de ${file.name}`}
                className="file-card__preview"
                showLabel
                build={() => ({
                  id: artifactId,
                  type: 'file',
                  title: file.name,
                  subtitle: file.type.label,
                  messageId,
                  payload: file,
                })}
              />
              <a className="file-card__download" href={file.url} download={file.name} aria-label={`Télécharger ${file.name}`}>
                <DownloadIcon size={15} />
                <span>Télécharger</span>
              </a>
            </span>
          </li>
        );
      })}
    </ul>
  );
}
